import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { CollectiblesAndAccessories } from '../../components';

import {
  collectiblesListingsErrorSelector,
  collectiblesListingsInProgressSelector,
  collectiblesListingsSelector,
} from './LandingPage.duck';

/**
 * Connects the landing-page collectibles section to SSR-loaded marketplace data.
 *
 * @component
 * @param {Object} props
 * @returns {JSX.Element}
 */
const CollectiblesAndAccessoriesContainer = props => {
  const { listings, inProgress, error } = props;

  return (
    <CollectiblesAndAccessories
      listings={listings}
      inProgress={inProgress}
      error={error}
    />
  );
};

const mapStateToProps = state => ({
  listings: collectiblesListingsSelector(state),
  inProgress: collectiblesListingsInProgressSelector(state),
  error: collectiblesListingsErrorSelector(state),
});

export default compose(connect(mapStateToProps))(CollectiblesAndAccessoriesContainer);
